import React, { useMemo } from "react";
import { Button, Input, Space, Typography, Card, Form, notification } from "antd";

const { Paragraph, Text } = Typography;

function pushDL(event, payload = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...payload });
}

export default function StepLead({ answers, setAnswers, onBack, onFinish }) {
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();

  const units = useMemo(
    () => [
      { key: "tatuape", label: "Óticas Bluevision\nTatuapé" },
      { key: "ipiranga", label: "Óticas Bluevision\nIpiranga" },
    ],
    []
  );

  const selectUnit = (unitKey) => {
    setAnswers((p) => ({ ...p, unit: unitKey }));
    form.setFieldsValue({ unit: unitKey });
    form.validateFields(["unit"]).catch(() => {});
    pushDL("bv_unit_selected", { unit: unitKey });
  };

  const finish = async () => {
    try {
      await form.validateFields();

      // pega valores REAIS do form no momento do clique
      const values = form.getFieldsValue();

      const finalAnswers = {
        ...answers,
        name: (values.name || "").trim(),
        unit: values.unit,
      };

      // ✅ evento final do quiz (sem PII)
      pushDL("bv_quiz_completed", {
        objective: finalAnswers.objective,
        hasPrescription: finalAnswers.hasPrescription,
        interest: finalAnswers.interest,
        unit: finalAnswers.unit,
        coupon: finalAnswers.coupon,
      });

      // ✅ chama o onFinish com os dados finais
      onFinish(finalAnswers);
    } catch (err) {
      api.warning({
        message: "Falta só um detalhe 🙂",
        description: "Preencha seu primeiro nome e selecione a unidade para continuar.",
        placement: "top",
      });
    }
  };

  return (
    <>
      {contextHolder}

      <Space direction="vertical" size={14} style={{ width: "100%" }}>
        <Card
          bordered={false}
          style={{ borderRadius: 16, background: "rgba(255,255,255,0.12)" }}
        >
          <Text style={{ color: "#fff", fontWeight: 800 }}>
            VOCÊ GARANTIU UM CUPOM ESPECIAL
          </Text>
          <Paragraph style={{ color: "rgba(255,255,255,0.9)", marginTop: 8 }}>
            Para ativá-lo chame a nossa equipe na unidade mais próxima e aproveite!
          </Paragraph>

          <div
            style={{
              display: "inline-block",
              padding: "10px 14px",
              borderRadius: 12,
              background: "#f4c400",
              fontWeight: 900,
            }}
          >
            CUPOM | {answers.coupon}
          </div>
        </Card>

        <Paragraph style={{ color: "rgba(255,255,255,0.9)", textAlign: "center" }}>
          Preencha os campos abaixo e entre em contato com a loja mais próxima.
        </Paragraph>

        <Form
          form={form}
          layout="vertical"
          initialValues={{ name: answers.name, unit: answers.unit }}
          requiredMark={false}
        >
          <Form.Item
            name="name"
            validateTrigger={["onBlur", "onChange"]}
            rules={[
              { required: true, message: "Digite seu primeiro nome." },
              { min: 2, message: "Digite pelo menos 2 letras." },
            ]}
          >
            <Input
              size="large"
              placeholder="Digite seu primeiro nome..."
              value={answers.name}
              onChange={(e) => {
                const v = e.target.value;
                setAnswers((p) => ({ ...p, name: v }));
                form.setFieldsValue({ name: v });
              }}
              style={{ borderRadius: 14, height: 52 }}
            />
          </Form.Item>

          <Form.Item
            name="unit"
            rules={[{ required: true, message: "Selecione a unidade." }]}
            style={{ marginBottom: 8 }}
          >
            <Input type="hidden" />
          </Form.Item>
        </Form>

        <Space style={{ width: "100%" }} size={10}>
          {units.map((u) => {
            const selected = answers.unit === u.key;
            return (
              <Button
                key={u.key}
                size="large"
                onClick={() => selectUnit(u.key)}
                style={{
                  flex: 1,
                  height: 56,
                  borderRadius: 14,
                  whiteSpace: "pre-line",
                  fontWeight: 800,
                  background: selected ? "#f4c400" : "rgba(255,255,255,0.12)",
                  color: selected ? "#111" : "#fff",
                  border: "none",
                }}
              >
                {u.label}
              </Button>
            );
          })}
        </Space>

        {form.getFieldError("unit")?.length > 0 && (
          <div style={{ color: "#ffccc7", fontSize: 13, textAlign: "center" }}>
            {form.getFieldError("unit")[0]}
          </div>
        )}

        <Space style={{ width: "100%" }} direction="vertical">
          <Button size="large" onClick={onBack} style={{ borderRadius: 14 }}>
            Voltar
          </Button>

          <Button type="primary" size="large" className="bv-primary" onClick={finish}>
            Finalizar e falar no WhatsApp
          </Button>

          <div
            style={{
              textAlign: "center",
              color: "rgba(255,255,255,0.75)",
              fontSize: 12,
            }}
          >
            Ao continuar, você concorda com nossa Política de Privacidade.
          </div>
        </Space>
      </Space>
    </>
  );
}